// components/gallery/GalleryTopics/index.jsx
import React, { useState, useEffect } from 'react';
import { galleryService } from '../../../services/gallery.service';
import LoadingScreen from '../../common/loading/LoadingScreen';
import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from '../../../config/firebase';
import {
    TopicsGrid,
    TopicCard,
    TopicImage,
    TopicInfo,
    TopicTitle,
    TopicDescription
} from './styles';

const GalleryTopics = () => {
    const [topics, setTopics] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTopics = async () => {
            try {
                const topicsData = await galleryService.getGalleryTopics();
                
                // Get download URLs for cover images
                const topicsWithImages = await Promise.all(
                    topicsData.map(async (topic) => {
                        const imageRef = ref(storage, topic.coverImage);
                        const coverImageUrl = await getDownloadURL(imageRef);
                        return {
                            ...topic,
                            coverImageUrl // Store the actual URL
                        };
                    })
                );
                
                setTopics(topicsWithImages);
            } catch (error) {
                console.error('Error:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchTopics();
    }, []);

    if (loading) return <LoadingScreen />;

    return (
        <TopicsGrid>
            {topics.map((topic) => (
                <TopicCard key={topic.id} to={`/gallery/${topic.id}`}>
                    <TopicImage src={topic.coverImageUrl} alt={topic.name} />
                    <TopicInfo>
                        <TopicTitle>{topic.name}</TopicTitle>
                        <TopicDescription>{topic.description}</TopicDescription>
                    </TopicInfo>
                </TopicCard>
            ))}
        </TopicsGrid>
    );
};

export default GalleryTopics;

